//@flow
import * as Immutable from 'immutable';

import {
    PjpInsightsMetadata,
    PjpMetadataGroupBy,
    PjpMetadataGroupByValues
} from 'common/models/flow/PjpInsightsMetadata';
import type {
    PjpInsightsMetadataModelType,
    PjpMetadataGroupByModelType,
    PjpMetadataGroupByValuesModelType
} from 'common/models/flow/PjpInsightsMetadata';

class InternalPjpInsightsMetadata extends PjpInsightsMetadata {
    static fromJS(
        json: PjpInsightsMetadataModelType
    ): InternalPjpInsightsMetadata {
        const state: Object = Object.assign({}, json);
        state.groupBy = Immutable.List(state.groupBy).map(item =>
            InternalPjpMetadataGroupBy.fromJS(item)
        );
        state.aggregation = Immutable.List(state.aggregation);
        return new this(Immutable.Map(state));
    }
}

class InternalPjpMetadataGroupBy extends PjpMetadataGroupBy {
    static fromJS(
        json: PjpMetadataGroupByModelType
    ): InternalPjpMetadataGroupBy {
        const state: Object = Object.assign({}, json);
        state.staticValues = Immutable.List(state.staticValues).map(item =>
            InternalPjpMetadataGroupByValues.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }
}

class InternalPjpMetadataGroupByValues extends PjpMetadataGroupByValues {
    static fromJS(
        json: PjpMetadataGroupByValuesModelType
    ): InternalPjpMetadataGroupByValues {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalPjpInsightsMetadata as PjpInsightsMetadata,
    InternalPjpMetadataGroupBy as PjpMetadataGroupBy,
    InternalPjpMetadataGroupByValues as PjpMetadataGroupByValues
};
